import React from 'react';

const CrossIcon = () => (
    <svg className="icon-cross" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
        <path d="M78.57,24.15,71.5,17.08a2,2,0,0,0-2.83,0l-19.3,19.3a2,2,0,0,1-2.83,0l-19.3-19.3a2,2,0,0,0-2.83,0l-7.07,7.07a2,2,0,0,0,0,2.83l19.3,19.3a2,2,0,0,1,0,2.83l-19.3,19.3a2,2,0,0,0,0,2.83l7.07,7.07a2,2,0,0,0,2.83,0L46.54,59a2,2,0,0,1,2.83,0l19.3,19.3a2,2,0,0,0,2.83,0l7.07-7.07a2,2,0,0,0,0-2.83l-19.3-19.3a2,2,0,0,1,0-2.83L78.57,27A2,2,0,0,0,78.57,24.15Z" />
    </svg>
);

export default React.memo(CrossIcon);
